import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Account } from '@smmof/entity';
import { SignInResPayloadDto } from '@smmof/dto';

export const AccountActions = createActionGroup({
  source: 'Account',
  events: {
    /** Установить данные аккаунта */
    'Set Account Data': props<{ account: Account }>(),
    /** Установить данные аккаунта */
    'Set Account Auth': props<{ token: SignInResPayloadDto }>(),
    /** Получить данные аккаунта */
    'Get Account Data': emptyProps(),
    /** Успешное получение данных аккаунта */
    'Get Account Data Success': props<{ account: Account }>(),
    /** Ошибка при получении данных аккаунта */
    'Get Account Data Failure': props<{ error: any }>(),

    'Clear account data': emptyProps(),
  },
});
